<headline-with-icon-and-info-box
  [icon]="'error'"
  [headline]="'COMMON.MAINTENANCE.TITLE.' + type | translate"
  [infoBoxHeadline]="'COMMON.MAINTENANCE.DESCRIPTION.' + type | translate"
>
</headline-with-icon-and-info-box>
